import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { CloseIcon, FileIcon } from '../../model/icons';

const FILE_KINDS = { IMAGE: 'image', VIDEO: 'video', AUDIO: 'audio', DOCUMENT: 'document' };

function detectKind(mime) {
    if (mime.startsWith('image/')) return FILE_KINDS.IMAGE;
    if (mime.startsWith('video/')) return FILE_KINDS.VIDEO;
    if (mime.startsWith('audio/')) return FILE_KINDS.AUDIO;
    return FILE_KINDS.DOCUMENT;
}

// Превью одного прикреплённого файла + удаление.
export default function FilePreview({ file, onRemove }) {
    const kind = useMemo(() => detectKind(file.type), [file.type]);
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (kind === FILE_KINDS.DOCUMENT) return undefined;
        const url = URL.createObjectURL(file);
        setPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [file, kind]);

    const sizeMb = (file.size / 1024 / 1024).toFixed(1);

    return (
        <div className="bc-file">
            <button type="button" className="rm" onClick={onRemove} aria-label="Удалить файл">
                <CloseIcon />
            </button>
            {kind === FILE_KINDS.IMAGE && preview && <img src={preview} alt={file.name} />}
            {kind === FILE_KINDS.VIDEO && preview && <video src={preview} controls preload="metadata" />}
            {kind === FILE_KINDS.AUDIO && (
                <div className="thumb"><FileIcon /></div>
            )}
            {kind === FILE_KINDS.DOCUMENT && (
                <div className="thumb"><FileIcon /></div>
            )}
            <div className="meta">
                <div className="fn">{file.name}</div>
                <div className="fs">{sizeMb} MB</div>
                {kind === FILE_KINDS.AUDIO && preview && <audio src={preview} controls />}
            </div>
        </div>
    );
}

FilePreview.propTypes = {
    file: PropTypes.instanceOf(File).isRequired,
    onRemove: PropTypes.func.isRequired
};
